import _createClass from "D:\\TS\\projects\\Tarkashilpa\\TS-Website\\sourcecode\\ts-website\\node_modules\\@babel\\runtime\\helpers\\esm\\createClass.js";
import _classCallCheck from "D:\\TS\\projects\\Tarkashilpa\\TS-Website\\sourcecode\\ts-website\\node_modules\\@babel\\runtime\\helpers\\esm\\classCallCheck.js";
export var EmailJSResponseStatus = /*#__PURE__*/_createClass(function EmailJSResponseStatus(httpResponse) {
  _classCallCheck(this, EmailJSResponseStatus);

  this.status = httpResponse.status;
  this.text = httpResponse.responseText;
});